import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Pagination } from '../../../common/pagination'
import { PAGE_SIZE_OPTIONS } from '../../constant'
import { changeFilter, selectFilter, selectTotalRecords } from '../store/slice'

export const PaginationTableDownload = () => {
  const dispatch = useDispatch()

  const page = useSelector(selectFilter('Page'))
  const pageSize = useSelector(selectFilter('PageSize'))
  const total = useSelector(selectTotalRecords)

  const handleSetPage = (value) => {
    dispatch(
      changeFilter({
        Page: value,
      }),
    )
  }
  const setPageSize = (value) => {
    dispatch(
      changeFilter({
        PageSize: value,
        Page: 1,
      }),
    )
  }

  return (
    <div style={{ paddingTop: 12 }}>
      <Pagination
        page={page}
        pageSize={pageSize}
        total={total}
        setPage={handleSetPage}
        setPageSize={setPageSize}
        pageSizeOptions={PAGE_SIZE_OPTIONS}
      />
    </div>
  )
}
